<template>
  <a-popconfirm
    :title="'feature-flags-delete.icon-remove-quest' | globalize"
    :ok-text="'feature-flags-delete.icon-remove-answer-yes' | globalize"
    :cancel-text="'feature-flags-delete.icon-remove-answer-no' | globalize"
    @confirm="onClick"
  >
    <a-button
      v-ripple
      :title="'feature-flags-delete.btn-remove' | globalize"
      type="default"
    >
      <i class="mdi mdi-trash-can-outline" />
    </a-button>
  </a-popconfirm>
</template>

<script>
import AButton from 'ant-design-vue/lib/button'
import APopConfirm from 'ant-design-vue/lib/popconfirm'

export default {
  name: 'feature-flags-delete',
  components: {
    AButton,
    'a-popconfirm': APopConfirm,
  },
  props: {
    onClick: {
      type: Function,
      default: () => {},
    },
  },
}
</script>
